export default {
      id: "h-03-usage",
      viewBox: "0 0 268 286",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#h-03",
      toString: function () {
        return this.url;
      }
    }